import React from 'react';
import { View ,Image , StyleSheet,Dimensions } from 'react-native';
import { TextInput, Button ,Snackbar, Text } from 'react-native-paper';

const theme = {
  colors: {
    primary: '#2ebbc4',
    accent: '#2ebbc4',
    text:'#3a3635'
  },
};

const viewH= Dimensions.get('window').height*0.6;

export default class App extends React.Component {

    state={
        phoneNumber: '',
        inputError : false,
        wrongNumberToast : false,
        buttonDisabled : false,
        connectionToast: false,
      };

      componentDidMount(){
        this._unsubscribe = this.props.navigation.addListener('focus', () => {
          this.setState({
            phoneNumber: '',
            inputError : false,
            wrongNumberToast : false,
            buttonDisabled : false,
            connectionToast: false,
          })
        });
      }

      componentWillUnmount() {
        this._unsubscribe();
      }


  render() {
    return (
        <View style={{ backgroundColor:'white' ,flex:1,justifyContent:'center',alignItems:'center'}}>
          
         <View style={{flex:1,justifyContent:'space-between',alignItems:'center',width:'100%', maxHeight:viewH,marginBottom:20}}>


        
          <View style={{marginRight:'auto', marginLeft:'auto'}}>
          <Image style={{marginLeft:'auto',marginRight:'auto',width:150, height:30 }} resizeMode='contain' source={require('../assets/img/logotype.png')}/>
          <Text style={{ fontSize:18, color:'#21706c',marginTop:15 }}>خوش آمدید</Text>
          <Text style={{ color:'#3a3635', fontSize: 12 }}>برای ورود لطفا شماره همراه خود را وارد نمایید</Text>
          </View>
          <TextInput
              theme={theme}
              style={styles.inputContainerStyle}
              label="شماره همراه"
              value={this.state.phoneNumber}
              onChangeText={phoneNumber => this.setState({ phoneNumber, inputError:false })}
              keyboardType="numeric"
              maxLength={11}
              selectionColor='#c4fbff'
              error = {this.state.inputError}
            />
            <Button mode='contained' dark={true} style={styles.button} color='#2ebbc4' loading={this.state.buttonDisabled} disabled={this.state.buttonDisabled}
             onPress={() => {
               let mobile = this.state.phoneNumber;
               let isValid = (mobile.length == 11) && (mobile.substr(0,2) == '09');
               this.setState({buttonDisabled : true});
               if (isValid) {
                 global.mobile = this.state.phoneNumber;
                 fetch('https://fitwayz.ir/api/auth/register',
                 {
                   method:'POST',
                   headers: {
                     Accept: 'application/json',
                     'Content-Type': 'application/json',
                   },
                   body: JSON.stringify({
                     mobile : global.mobile,
                     fname : 'Unverified User',
                     lname : 'Unverified User',
                     gender : 0,
                     image : null,
                   })
                 }).then(response => response.json()).then(responseJson => {
                        console.log(responseJson);
                      if (responseJson.result == 'success'){
                        this.props.navigation.navigate('Validation')
                      } else{
                        fetch('https://fitwayz.ir/api/auth/password/reset',
                        {
                          method:'POST',
                          headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                          },
                          body: JSON.stringify({
                            mobile : global.mobile
                          })
                        }).then(response1 => response1.json()).then(responseJson1 => {
                          console.log(responseJson1);
                          if (responseJson1.result == 'success'){
                            this.props.navigation.navigate('Validation')
                          } else {
                            console.log(responseJson1)
                          }
                        })
                        .catch(error => {
                          console.log('here')
                          console.log(error)
                          this.setState({buttonDisabled: false,connectionToast:true});
                        });
                      }
                      })
                      .catch(error => {
                        console.log(error)
                        this.setState({buttonDisabled: false,connectionToast:true});
                      });


               } else {
                 this.setState({inputError:true, wrongNumberToast:true, buttonDisabled: false})

               }

               
             }
            } 
            contentStyle={{width:170,height:46}}>ادامه</Button>

        </View>

        <Snackbar
          style={{zIndex:200}}
          visible={this.state.wrongNumberToast}
          onDismiss={() => this.setState({ wrongNumberToast: false })}>
          شماره همراه نا معتبر است. مثال 09133401234
        </Snackbar>

        <Snackbar
          style={{zIndex:200}}
          visible={this.state.connectionToast}
          onDismiss={() => this.setState({ connectionToast: false })}>
         ارتباط اینترنت با مشکل مواجه است
        </Snackbar>


        <Text style={{ color:'#3a3635', fontSize: 10,position:'absolute',bottom:10, marginLeft:'auto', marginRight:'auto'}}
        onPress={()=> this.props.navigation.navigate('Terms')}
        >با ثبت نام در "فیت ویز" شرایط و مقررات آن را میپذیرم</Text>
        
        </View>
    );
  }
}

const styles = StyleSheet.create({
    inputContainerStyle: {
      marginLeft: 'auto',
      marginRight:'auto',
      width: '65%',
      backgroundColor:'white',
      marginVertical:30,
    },
    button:{
      marginLeft:'auto',
      marginRight:'auto',
      borderRadius:23,
      marginTop:20
    },

  });
  
